module.exports = {
  title: '官网',
  baseUrl: 'https://tianyinadmin.tianyinsaas.cn', // 测试项目地址
  baseApi:'https://tianyinadmin.tianyinsaas.cn'//// 测试api请求地址
};
